<template>
    <div class="card-orcamento-final-produto-novo">
        <g-card
        :temCabecalho = "false"
        >
            <div class="header-card-orcamento-final">

                <div class="header-orcamento-titulo">
                    <div class="amostralote-titulo"> AMOSTRA / LOTE </div>
                </div>

                <!-- <div class="unidade-representante">
                    <div class="representante">
                        <div class="representante-label"> Representante: &nbsp;</div>
                        <div class="representante-conteudo"></div>
                    </div>

                    <div class="unidade">
                        <div class="unidade-label"> Empresa: &nbsp;</div>
                        <div class="unidade-conteudo"></div>
                    </div>
                </div> -->

                <div class="header-icons">
                    <g-button
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_compartilhar.svg"
                    >
                    </g-button>

                    <g-button
                    @click="pdfFinal()"
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_print.svg"
                    >
                    </g-button>


                </div>
            </div>

            <div class="orcamento-final-conteudo">
                <div class="grupo-cliente">
                    <div class="grupo"> CLIENTE</div>
                    <div class="topico">
                        <div class="cliente-pedido">
                            <div class="pedido titulo"> Pedido </div>
                            <div class="pedido conteudo">{{this.Pedido}}</div>
                        </div>

                        <div class="cliente-empresa">
                            <div class="empresa titulo" > Empresa </div>
                            <div class="empresa conteudo"> {{this.Empresa}} </div>
                        </div>

                        <div class="cliente-representante">
                            <div class="representante titulo"> Representante </div>
                            <div class="representante conteudo"> {{this.Representante}}</div>
                        </div>

                        <div class="cliente-cliente">
                            <div class="cliente titulo"> Cliente </div>
                            <div class="cliente conteudo">{{this.Cliente}}</div>
                        </div>
                    </div>
                </div>

                <div>
                  <div class="consumo-produto">
                    <div class="previsao-produto">
                      <div class="consumo-titulo titulo"> Consumo previsto para o produto </div>
                    <div class="consumo-drop">
                      <PInputText
                        class="consumo-input input-label"
                        type="number"
                        maxlength="12"
                        v-model="this.novoCheckAmostra.DescricaoConsumo"
                        @keypress="camponumero"
                        />
                        <div class="lote_container">
                            <label class= "consumo-titulo entrecampos"> por </label>
                            <PDropDown
                            class="lote-input input-drop"
                            v-model="this.novoCheckAmostra.DataConsumo"
                            :options="loteArray"
                            optionLabel="text"
                            optionValue="enum"
                            />
                        </div>
                    </div>
                    </div>
                  </div>
                </div>

                <div class="grupo-demaisCaract">
                    <div class="grid-grupo-demaisCaract">
                        <div class="demaisCaract-gerais">
                            <div class="homogacaogrupo checkbox">
                                <PCheckBox id="homogacaogrupo" :binary="true" v-model="novoCheckAmostra.Homologacao"/>
                                <label for="HOMOGACAOGRUPO" class="checkboxGerais label-checkbox"> Homologação do Grupo como Fornecedor </label>
                            </div>
                            <div class="aprovacao-cor checkbox">
                                <PCheckBox id="aprovacao-cor" :binary="true" v-model="novoCheckAmostra.AprovacaoPadraoCor"/>
                                <label for="aprovacao-cor" class="checkboxGerais label-checkbox"> Aprovação padrão de Cor </label>
                            </div>
                            <div class="colecao-cliente checkbox">
                                <PCheckBox id="colecao-cliente" :binary="true" v-model="novoCheckAmostra.Colecao"/>
                                <label for="colecao-cliente" class="checkboxGerais label-checkbox"> Mudança de coleção do cliente </label>
                            </div>
                            <div class="aprovacao-maquina checkbox">
                                <PCheckBox id="aprovacao-maquina" :binary="true" v-model="novoCheckAmostra.AprovacaoEmMaquinaCliente"/>
                                <label for="aprovacao-maquina" class="checkboxGerais label-checkbox"> Aprovação de maquina do cliente </label>
                            </div>
                            <div class="aprovacao-materiaprima checkbox">
                                <PCheckBox id="aprovacao-materiaprima" :binary="true" v-model="novoCheckAmostra.AprovacaoEmMateriaPrima"/>
                                <label for="aprovacao-materiaprima" class="checkboxGerais label-checkbox"> Aprovação de Matéria-Prima </label>
                            </div>
                            <div class="necessidade-tecnica checkbox">
                                <PCheckBox id="necessidade-tecnica" :binary="true" v-model="novoCheckAmostra.NecessidadeTecnica"/>
                                <label for="necessidade-tecnica" class="checkboxGerais label-checkbox"> Necessidade técnica do Grupo </label>
                            </div>
                            <div class="exportacao-exigencia checkbox">
                                <PCheckBox id="exportacao-exigencia" :binary="true" v-model="novoCheckAmostra.Exportacao" />
                                <label for="exportacao-exigencia" class="checkboxGerais label-checkbox"> Exportação-Exigencia para homologação </label> 
                            </div>
                            <div class="custo-aprovado checkbox">
                                <PCheckBox id="custo-aprovado" :binary="true" v-model="novoCheckAmostra.ProdutoCustoAprovado" />
                                <label for="custo-aprovado" class="checkboxGerais label-checkbox"> Este produto tem custo aprovado </label> 
                            </div>
                            <div class="amostra-enviada checkbox">
                                <PCheckBox id="amostra-enviada" :binary="true" v-model="novoCheckAmostra.ClienteAceitaMaterialDiferenteDaAmostra"/>
                                <label for="amostra-enviada" class="checkboxGerais label-checkbox"> Cliente aceita opção de material diferente da amostra enviada </label> 
                            </div>
                        </div>

                        <div class="demaisCaract-critica">
                            <div class="grid-demaisCaract-critica">
                                
                                
                                <div class="arquivo-eletronico checkbox">
                                    <PCheckBox id="arquivo-eletronico" :binary="true" v-model="novoCheckAmostra.ProdutoPossuiArquivoEletronico"/>
                                    <label for="arquivo-eletronico" class="checkboxGerais label-checkbox"> Possui arquivo eletronico </label> 
                                </div>
                                <div class="cartelas-padrao-cor checkbox">
                                    <PCheckBox id="cartelas-padrao-cor" :binary="true" v-model="novoCheckAmostra.CartelaDeCorEspecifica"/>
                                    <label for="cartelas-padrao-cor" class="checkboxGerais label-checkbox"> Cliente possui cartelas padrão cor específico </label> 
                                </div>
                                <div class="amostra-concorrente checkbox">
                                    <PCheckBox id="amostra-concorrente" :binary="true" v-model="novoCheckAmostra.ProdutoFeitoPorConcorrente" @click="checkConcorrente"/>
                                    <label for="amostra-concorrente" class="checkboxGerais label-checkbox"> Este produto é feito / homologado por algum concorrente no Brasil </label> 
                                </div>
                            </div>
                                <div class="amostra-qual checkbox">
                                    <!-- <PCheckBox id="amostra-qual" :binary="true" v-model="novoCheckAmostra.NomeConcorrente" /> -->
                                    <label for="amostra-qual" class="checkboxGerais label-checkbox"> Qual? </label> 
                                </div>
                                <div class="input-Qual">
                                  <PInputText 
                                      :disabled="novoCheckAmostra.ProdutoFeitoPorConcorrente === false || novoCheckAmostra.ProdutoFeitoPorConcorrente === undefined"
                                      class="quantidade-input input-inputtext" 
                                      v-model="novoCheckAmostra.NomeConcorrente"
                                      maxlength="50"
                                    />
                                </div>
                                <div class="amostra-outros checkbox">
                                    <PCheckBox id="amostra-outros" :binary="true" v-model="novoCheckAmostra.OutrosCheck" @click="checkOutros"/>
                                    <label for="amostra-outros" class="amostralote-label label-checkbox"> Outros </label> 
                                </div>
                                <div class="input-Outros">
                                  <PInputText 
                                      :disabled="novoCheckAmostra.OutrosCheck === false || novoCheckAmostra.OutrosCheck === undefined"
                                      class="quantidade-input input-inputtext" 
                                      v-model="novoCheckAmostra.Outros"
                                    />
                                </div>
                                <div class="ratio-proc-ind-com">
                                  <div class="loteFrete-prototipo">
                                    <label for="industrializacao-comercializacao" class="amostralote-label label-checkbox"> Produto será utilizado no processo de industrialização ou comercialização? </label> 
                                    <div class="ratio-ind-com">
                                        <div class="ratio-ind-com-sim">
                                            <PRadioButton
                                            class="sim-input input-label-ratio"
                                            name="sim"
                                            :value="true"
                                            v-model="novoCheckAmostra.ProdutoIndustrializacaoComercializacao"
                                            />
                                            <div class="ratio-sim-titulo label-ratio"> Sim </div>
                                        </div>
                                            <div class="ratio-ind-com-nao">
                                            <PRadioButton
                                            class="nao-input input-label-ratio"
                                            name="nao"
                                            :value="false"
                                            v-model="novoCheckAmostra.ProdutoIndustrializacaoComercializacao"
                                            />
                                            <div class="ratio-nao label-ratio"> Não </div>
                                        </div>
                                    </div>
                                  </div>


                                    
                                </div>                                
                        </div>
                    </div>
                </div> 

                <div class="grupo-cliente">
                    <div class="grupo"> Reprovação</div>
                    <div class="observacoes-reprovacao">
                        <div class="reprovacao-checkbox checkbox">
                            <div class="reprovacao">
                            <PCheckBox id="reprovacao-checkbox" :binary="true" v-model="novoCheckAmostra.Reprovacao" @click="checkReprovacao"/>
                            <label for="reprovacao-checkbox" class="amostralote-label label-checkbox"> É Reprovação? </label></div>
                            <div class= "motivo-reprovacao">
                                <div class="label-conteudo"> Qual motivos da reprovação?
                                <PTextArea  id="obsGerais" 
                                            rows="4" cols="60" 
                                            :disabled="novoCheckAmostra.Reprovacao === false || novoCheckAmostra.Reprovacao === undefined"
                                            v-model ="novoCheckAmostra.MotivoReprovacao"
                                            ></PTextArea>  
                                </div>
                            </div>
                            <div class="reprovacao-anexo">
                            <PCheckBox id="exportacao-exigencia" :binary="true" v-model="novoCheckAmostra.MaterialReprovadoEmAnexo" />
                            <label for="exportacao-exigencia" class="amostralote-label label-checkbox"> O material reprovado esta anexo ao novo processo / pedido? </label></div>
                        </div>
                    </div>
                    <div class="grupo"> Observações</div>
                    <div class="observacoes-reprovacao">
                       <div class="reprovacao-checkbox checkbox">
                            <PTextArea  class="p-inputtext-observacoes"
                                        id="obsGerais" 
                                        v-model="novoCheckAmostra.Observacoes" 
                                        rows="4" cols="60"
                                        maxlenght="150" ></PTextArea> 
                        </div>
                    </div>
                </div>
                
            </div>

            <div class="btnOrcamento">
                <g-button class="btnNovoOrcamento" negritoTexto tamanhoTexto="15px" @click="abrePopup"> FINALIZAR </g-button>
                <g-button class="btnVerOrcamento" negritoTexto tamanhoTexto="15px" tipo="cinza" @click="voltarstep4" > CANCELAR </g-button>
            </div>



            <div class="popup-amostralote">
                <PDialog :showHeader=false :closable="false" v-model:visible="popup" :modal="true" >
                <!-- <div class="conteudo-popup-edicao"> O pedido 123456 incluido com sucesso! </div> -->
                <div class="conteudo-popup-edicao"> O formulario gravado com sucesso! </div>

                <!-- <div class="conteudo-popup-texto"> O numero do formulário  é 1234 </div> -->
                    <div class="amostra-lotepopup">
                        <div class="botao-retornar">
                            <g-button largura="100%" negritoTexto @click="finalizacao"> Retornar </g-button>
                        </div>
                    </div>
                </PDialog>
            </div>


        </g-card>
    </div>
</template>

<script>
import PedidoAmostraLote from './PedidoAmostraLote.js'
export default PedidoAmostraLote
</script>

<style scoped>

.input-Outros, .input-Qual{
    padding: 3px 0;
}

.input-inputtext{
    display:flex;
}

.popup-amostralote {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 2%;
}

.conteudo-popup-edicao { 
  grid-area: 1 / 1 / 2 / 2;
  color: #4E4E4E;
  text-align: center;
  font-weight: 600;
  font-family: 'MontSerrat';
  margin-top: 25px;
  margin-bottom: 15px;
}

.conteudo-popup-texto { 
  grid-area: 1 / 1 / 2 / 2;
  color: #4E4E4E;
  text-align: center;
  font-weight: 600;
  font-family: 'MontSerrat';
  margin-top: 50px;
  margin-bottom: 15px;
}

.amostra-lotepopup {
  display:grid;
  grid-template-columns: 100%;
  grid-template-rows: 100%;
  grid-column-gap: 5%;
}

.entrecampos{
    padding: 5px 5px 0px 0px;
    display: flex;
    grid-template: entrecampos;
}

.motivo-reprovacao{
    padding: 15px 0px ;
}

 .label-ratio{
    color: #8A8A8A;
    text-align: left;
    font-size: 15px;
    font-family: 'MontSerrat';
    padding-left: 15px;
 }

.ratio-ind-com-nao{
    display: flex;
}


.ratio-ind-com-sim{
    display: flex;
}

.ratio-ind-com{
    display: grid;
    grid-template-columns: repeat(2, 35%);
    padding-top: 3px;
}

.reprovacao {
    padding-top: 15px;
    display: flex;
}

.reprovacao-anexo{
    display:flex;
}

.input-label {
  width: 100%;
}

.ratio-proc-ind-com {
    padding: 3px 0 3px 0;
    display: grid;
    justify-items: start;
}

.amostralote-titulo {
    color:#4F2C19;
    text-align: left;
    font-weight: bold;
}

.container-logo{
  padding: 30px 30px 10px 30px;
}

.orcamentoInfo-subtitulo { font-size: 15px; }

.representante, .unidade { display: flex; }

.representante-label, .unidade-label, .orcamentoInfo-subtitulo {
    color:#4F4C4D;
    font-family: 'MontSerrat';
    font-weight: bold;
    text-align: left;
    display: flex;
}

.representante-conteudo, .unidade-conteudo {
    color: #3E3E3E;
    font-family: 'MontSerrat';
    text-align: left;
    font-weight: 500;
}

.header-icons {
    display: flex;
    flex-direction: row;
    column-gap: 5px;
}

.topico { 
    padding-bottom: 10px;
}

.grid-grupo-infoBasicas, .grid-grupo-demaisCaract { border-top: 1px solid #e1e1e1; }

.grupo {
    color: #4f2c19;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: bold;
    margin-top: 30px;
    display: flex;
}

.titulo {
    color: #3E3E3E;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: 500;
    margin-top: 15px;
}

.conteudo {
    color: #8A8A8A;
    text-align: left;
    font-family: "MontSerrat";
    margin-bottom: 10px;
}

.checkbox {
    display: flex;
    padding-top: 3px;
    padding-bottom: 3px;
}
.label-checkbox, .label-conteudo{
    color: #8A8A8A;
    text-align: left;
    font-size: 15px;
    font-family: 'MontSerrat';
}
.label-checkbox { margin-left: 5px; }

.btnOrcamento {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 50px;
    row-gap: 15px;
    margin-top: 50px;
}

.p-disabled, .p-component:disabled {
    opacity: 1;
}
.p-inputtext {
    width: 100%;
}

.p-inputtext-observacoes {
    margin-top: 15px;
    width: 100%;
}

.p-button {
    margin-top: 0;
    padding-top: 0;
}

.lote_container{
    display: flex;
    flex-direction: row;
    width: 100%;
}


@media (min-width: 310px) {

.lote_container{
    display: flex;
    flex-direction: row;
    width: 100%
}

.input-drop {
  width: 100%;
}

.entrecampos{
    padding: 0px 5px 0px 0px;
    display: flex;
    align-items: center;
}

.ratio-ind-com{
    display: grid;
    grid-template-columns: repeat(2, 90px);
}

.consumo-drop{
    display: grid;
    padding: 15px 0;
    row-gap: 15px;
}


.header-card-orcamento-final {
    display: grid;
    grid-template-columns: auto 25%;
    grid-column-gap: 10px;
    margin-top: 20px;
}

.reprovacao-checkbox{ display: grid;}


.header-icons { grid-area: 1 / 3 / 2 / 4; justify-content: flex-end; }
.unidade-representante {
    grid-area: 2 / 1 / 3 / 4;
    border-top: 1px solid #e1e1e1;
    width: 100%;
    padding-top: 10px;
    margin-top: 10px;
}

.orcamentoInfo-subtitulo { display: none; }

.representante-label, .unidade-label, .representante-conteudo, .unidade-conteudo { font-size: 15px; }

.orcamento-final-conteudo, .header-card-orcamento-final { padding-right: 10px; padding-left: 10px; }

.grid-grupo-demaisCaract {
    display: flex;
    flex-direction: column;
    row-gap: 0px;
}

.topico {
  display: grid;
  flex-wrap: wrap;
  column-gap: 15%;
  border-top: 1px solid #e1e1e1;
}

.grid-grupo-infoBasicas, .grid-grupo-demaisCaract {
    padding-top: 10px;
    border-top: 1px solid #e1e1e1;
}

.grupo { font-size: 18px; }

}



@media (min-width:368px) {
.amostralote-titulo { font-size: 20px; }
}



@media (min-width:600px) {

.consumo-drop{
    display: flex;
    padding: 15px 0 15px 0;
}

.amostralote-titulo { font-size: 22px; }

.grid-grupo-infoBasicas {
    display: grid;
    grid-template-columns: 48% auto;
    grid-template-rows: repeat(4, auto);
    grid-column-gap: 20px;
}
.orcamento-final-conteudo, .header-card-orcamento-final { padding-right: 20px; padding-left: 20px; }

.topico {
    display: grid;
    border-bottom: none;
    margin-top: 10px;
    column-gap: 5%;
    grid-template-columns: repeat(2, auto);
}

.observacoes-reprovacao {
  display: grid;
  flex-wrap: wrap;
  column-gap: 15%;
  border-top: 1px solid #e1e1e1;
}

.entrecampos{
    padding: 0px 5px 0px 5px;
    display: flex;
    align-items: center;
}

}

@media (min-width:801px) {

.representante-label, .unidade-label, .representante-conteudo, .unidade-conteudo { font-size: 17px; }

.grid-grupo-infoBasicas {
    grid-template-rows: repeat(3, auto);
}

.grid-grupo-demaisCaract {
    display: grid;
}

.grid-caractProd-critica, .grid-caractProd-embalagem {
    display: grid;
    grid-template-columns: 50% auto;
    grid-template-rows: repeat(3, auto);
    grid-column-gap: 20px;
}

.colecao-cliente, .aprovacao-maquina, .aprovacao-materiaprima, .embalagem-outros {
    align-self: flex-end;
}

.demaisCaract-gerais { 
    grid-area: 1 / 1 / 2 / 2; 
}
.demaisCaract-critica {
    grid-area: 1 / 3 / 2 / 4;     
    
}

}

@media (min-width:1025px) {
.header-card-orcamento-final {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
}

.orcamento-final-imagem { grid-area: 1 / 1 / 3 / 2; width: 100%; }
.header-orcamento-titulo { grid-area: 1 / 2 / 2 / 3; }
.header-orcamento-subtitulo { grid-area: 2 / 2 / 3 / 3; }
.header-icons { grid-area: 1 / 3 / 2 / 4; }
.unidade-representante {
    grid-area: 2 / 3 / 3 / 4;
    border: none;
    align-self: flex-start;
    justify-self: flex-end;
    padding-top: 0;
    margin-top: 0;
    width: auto;
}

.orcamento-final-img {
    height: 5rem;
}

.amostralote-titulo { font-size: 25px; }
.orcamentoInfo-subtitulo { display: block; font-size: 16px; }

.topico {
    display: grid;
    border-bottom: none;
    margin-top: 10px;
    column-gap: 5%;
    grid-template-columns: repeat(4, auto);
}

.grid-grupo-infoBasicas {
    grid-template-columns: repeat(4, auto);
    grid-template-rows: repeat(2, auto);
}


.demaisCaract-gerais { 
    grid-area: 1 / 1 / 2 / 2; 
}
.demaisCaract-critica { 
    grid-area: 1 / 2 / 1 / 4;
}

.infoBasicas-nomeProduto { grid-area: 1 / 1 / 2 / 2; }
.infoBasicas-amostraRef { grid-area: 1 / 2 / 2 / 3; }
.infoBasicas-quantidade { grid-area: 1 / 3 / 2 / 4; }
.infoBasicas-diaCarregamento { grid-area: 1 / 4 / 2 / 5; }
.infoBasicas-observacao { grid-area: 2 / 1 / 3 / 5; }
}

@media (min-width:1281px) {
.orcamento-final-conteudo, .header-card-orcamento-final { padding-right: 40px; padding-left: 40px; }

.grid-grupo-infoBasicas {
    grid-template-columns: repeat(4, auto) 10%;
}
.infoBasicas-observacao { grid-area: 2 / 1 / 3 / 6; }


.demaisCaract-gerais { 
    grid-area: 1 / 1 / 2 / 2;     

    }
.demaisCaract-critica { 
    grid-area: 1 / 2 / 1 / 4;

    }
}

@media (min-width:1500px) {
.orcamento-final-conteudo, .header-card-orcamento-final { padding-right: 60px; padding-left: 60px; }
}
</style>



